/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Teampausereasons2Inputs */

const en_entity_teampausereasons2 = /** @type {(inputs: Entity_Teampausereasons2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Pause Reasons`)
};

const de_entity_teampausereasons2 = /** @type {(inputs: Entity_Teampausereasons2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausegründe`)
};

/**
* | output |
* | --- |
* | "Team Pause Reasons" |
*
* @param {Entity_Teampausereasons2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_teampausereasons2 = /** @type {((inputs?: Entity_Teampausereasons2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Teampausereasons2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_teampausereasons2(inputs)
	return de_entity_teampausereasons2(inputs)
});
export { entity_teampausereasons2 as "entity_teamPauseReasons" }